import BigNumber from 'bignumber.js'

// Utility functions
/**
 * 格式化数字为千分位显示
 * @param value - 要格式化的数字或字符串
 * @param decimals - 保留的小数位数，默认为6位
 * @returns 格式化后的字符串
 *
 * @example
 * formatThousands(10001.123, 6) // "10,001.123000"
 * formatThousands(10001.1234567, 6) // "10,001.123456"
 * formatThousands("1000000", 2) // "1,000,000.00"
 * formatThousands(0.123456789, 4) // "0.1234"
 */
export const formatThousands = (
  value: number | string,
  decimals: number = 6
): string => {
  try {
    // 使用 BigNumber 处理精度问题
    const bn = new BigNumber(value || '0')

    // 处理无效输入
    if (bn.isNaN()) {
      return '0'
    }

    // 固定小数位数（截断，不四舍五入）
    const fixed = bn.decimalPlaces(decimals, BigNumber.ROUND_DOWN)

    // 分离整数和小数部分
    const [integerPart, decimalPart = ''] = fixed.toString().split('.')

    // 格式化整数部分（添加千分位逗号）
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    // 如果需要小数位，补齐到指定位数
    if (decimals > 0) {
      const paddedDecimal = (decimalPart || '').padEnd(decimals, '0')
      return `${formattedInteger}.${paddedDecimal}`
    }

    return formattedInteger
  } catch (error) {
    console.warn('formatThousands error:', error)
    return '0'
  }
}
